/*global LOADER_PAGES */
import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import BaseComponent from '../BaseComponent';

const NAME = 'BodyLoader';
class BodyLoader extends BaseComponent {

	static get NAME() {
		return NAME;
	}

	constructor(element) {
		super(element);
		this.sortBy = SelectorEngine.findOne('#sortByFilter');
		this.selected = this.sortBy ? this.sortBy.options[this.sortBy.selectedIndex] : undefined;
		this.pagination = SelectorEngine.find('.lta-pagination button, .lta-pagination a');
		this.searchField = SelectorEngine.findOne('.lta-search-field__button');
		this.searchInput = SelectorEngine.findOne('.js-location-search-field-input');
		this.img = SelectorEngine.findOne('body.lta-loader > img.clip-animation');
		this.shouldSkipLoader = false;
		this.initLoader();
		this.initEventHandler();

	}

	initEventHandler() {
		EventHandler.on(document, 'click', (event) => {
			if (event.target.attributes.href !== undefined && LOADER_PAGES.includes(event.target.attributes.href.value) && !this.shouldSkipLoader) {
				document.body.className = 'lta-loader in-out-animation';
			}
		});

		if (LOADER_PAGES.includes(window.location.pathname)) {
			const initValue = this.searchInput?.value;
			// Second option for not checking all those events
			// EventHandler.on(window, 'beforeunload', () => {
			// 	if ((document.activeElement.href !== undefined && LOADER_PAGES.indexOf(e.target.attributes.href.value) >= 0) || document.activeElement.href === undefined ) {
			// 		this.addLoader();
			// 	}
			// });

			document.addEventListener(
				'click',
				(event) => {
					if (
						(event.target.classList.contains('lta-search-field__button') &&
							this.searchInput?.value.length > 0 &&
							initValue !== this.searchInput?.value) ||
						event.target.classList.contains('lta-filter-panel__btn')
					) {
						this.addLoader();
					}
				},
				true
			);
			for (const page of this.pagination) {
				EventHandler.on(page, 'click', this.addLoader);
			}
			if (this.sortBy && this.selected) {
				EventHandler.on(this.sortBy, 'change', (event) => {
					const newSelect = event.target.options[event.target.selectedIndex];
					if (newSelect != this.selected) this.addLoader();
				});
			}
		}
	}

	initLoader() {
		// Using one time eventhandler since it seems that due to some ajax requests on some pages the event was firing more than once and messed up the
		// case where the loader was added before unloading the page on some form submissions ealrier than expected.
		EventHandler.one(window, 'load', () => {
			this.img = SelectorEngine.findOne('body.lta-loader > img.clip-animation');
			if ( document.readyState == 'complete') {
				this._element.classList.add('lta-loader--close');
				this.img?.classList.add('hide-img');
				EventHandler.one(this.img, 'transitionend', () => {
					setTimeout( () => {
						this._element.classList.remove('lta-loader');
						this._element.classList.remove('lta-loader--close');
						this.img?.classList.remove('hide-img');
					}, 1000);
				});
			}
		});
	}

	addLoader() {
		document.body.className = 'lta-loader in-out-animation';
	}
}

export default BodyLoader;
